<template lang="pug">
pr-wrapper.popup.animated(bg, :bgo="'0'", fs, :zi="index", v-visible="activated")
  pr-wrapper.animated.d-flex(
    v-nv:scope="'popup'",
    nv-exit-protect,
    @nv-exit.native="skipped",
    @nv-back.native="skipped",
    @nv-left.native="prevSlideshow",
    @nv-right.native="nextSlideshow"
  )
    .buttons
      pr-button.background(v-nv, v-if="skip", @nv-enter.native="skipped") 
        pr-text {{ $t(skip === true ? 'press.okToClose' : skip) }}
        pr-text.ml-2(v-show="time") {{ `(${time})` }}
      pr-button.background.ml-2(v-nv, v-show="slideshow", v-visible="slideControl", @nv-enter="toggleSlideshow")
        icon(:icon="'fas ' + (slideStatus ? 'pause' : 'play')")
</template>

<script>
export default {
  name: "popup",
  data() {
    return {
      activated: false,
      payload: {},
      lastNavigation: null,
      index: "0",
      interval: null,
      time: 0,
      slideStatus: false,
      slideControl: false
    }
  },
  computed: {
    slideshow() {
      return this.payload.type === "slideshow" && Array.isArray(this.payload.image) && this.payload.image.length > 1 ? true : false
    },
    image() {
      if (this.payload.type === "image") return true
      return this.payload.type === "slideshow" && Array.isArray(this.payload.image) && this.payload.image.length === 1 ? true : false
    },
    video() {
      return this.payload.type === "video"
    },
    skip() {
      return (this.image || this.video) && this.payload.skip
    }
  },
  watch: {
    activated(nval) {
      this.$emit("activate", { name: this.$options.name, state: nval })
      this.index = nval ? "107" : "0"

      if (!this.slideshow) return
      this.slideStatus = true
      this.slideControl = true
    }
  },
  mounted() {
    _$.vue.$on("popup", this.activate)
    _$.vue.$on("beforeRoute", () => this.close("abort"))
    _$.vue.$on("sleep", () => (this.slideControl = false))
  },
  methods: {
    async activate(payload) {
      if (!payload) return this.close("abort")
      else if (payload === "skip") return this.skipped(true)
      if (this.activated) return false

      _$.vue.$emit("actions", "pause")
      this.payload = payload

      await this.$nextTick()

      this.lastNavigation = this.lastNavigation || { current: _$.nav.getCurrentScope(), prev: _$.nav.getPrevScope() }

      if (this.slideshow) this.slideControl = true

      return this.prepare()
    },
    async prepare() {
      const tempState = __.platform.popState()
      await __.platform.toPlatform().then(() => __.platform.saveState(tempState))

      this.activated = true

      document.getElementById("background-image-container").style.opacity = "0"
      __.platform.fullscreen(true)
      __.common.tvWindowResize()

      await this.$nextTick()

      let result = false
      switch (this.payload.type) {
        case "image":
        case "slideshow":
          result = await __.platform.background(this.payload.image, this.payload.video, true)
          document.getElementById("background-image-container").style.opacity = "1"
          break
        case "video":
          __.platform.background()
          result = await __.media.play(this.payload.video, this.payload.loop || false)
          break
      }

      if (!result) return this.close()

      if (this.payload.skipAfter >= 5000) {
        this.time = Math.round(this.payload.skipAfter / 1000)
        this.interval = setInterval(() => {
          this.time--
          if (!this.time) clearInterval(this.interval)
        }, 1000)
      }

      let events = ["mediaError"]
      if (!this.payload.loop) events = [...events, "mediaEnded", "mediaStopped"]
      _$.vue.$off(events, this.skipped).$once(events, this.skipped)

      if (this.payload.playerControl) _$.nav.changeScope("player")
      else _$.nav.sync("popup", true).then(() => _$.nav.disable(["exit", "back", "home", "left", "right", "enter"], true))
    },
    async skipped(force = false) {
      if (!this.activated) return false
      let hasError = false

      if (typeof force === "object" && force.type === "mediaError") {
        hasError = true
        this.time = 0
        force = true
      } else force = false

      if (!force && this.time) return false

      let events = ["mediaError"]
      if (!this.payload.loop) events = [...events, "mediaEnded", "mediaStopped"]
      _$.vue.$off(events, this.skipped)

      this.clearSkipData()

      await __.platform.background()
      await this.$nextTick()

      this.close(true, !hasError)
    },
    async close(reason, resolve) {
      if (!this.activated) return false
      this.clearSkipData()
      document.getElementById("background-image-container").style.opacity = "1"

      if (this.lastNavigation && reason !== "abort") {
        __.platform.fullscreen(false)

        if (this.lastNavigation.current) _$.nav.changeScope(this.lastNavigation.current.name)
        _$.nav._prevScope = this.lastNavigation.prev

        await __.platform.loadState()
      }

      this.lastNavigation = null
      this.activated = false

      setTimeout(() => _$.vue.$emit("actions", "play"), 1000)

      if (resolve) return this.payload.resolve(resolve)
      else return this.payload.reject()
    },
    clearSkipData() {
      this.time = 0
      clearInterval(this.interval)
    },
    toggleSlideshow() {
      if (!this.slideshow) return
      this.slideStatus = !this.slideStatus
      this.slideControl = true
      _$.vue.$emit("background", "toggle")
    },
    nextSlideshow() {
      if (!this.slideshow) return
      if (this.slideStatus) this.toggleSlideshow()
      _$.vue.$emit("background", "next")
    },
    prevSlideshow() {
      if (!this.slideshow) return
      if (this.slideStatus) this.toggleSlideshow()
      _$.vue.$emit("background", "prev")
    }
  }
}
</script>

<style lang="scss" scoped>
#popup {
  z-index: 1;
  position: absolute;
  height: 100%;
  width: 100%;
  flex-direction: column;

  .buttons {
    position: relative;
    z-index: 2;
    padding: 10px;
    text-align: right;
    .background {
      display: inline-flex;
    }
  }
}
</style>
